import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { WebClientService } from '../../services/webclient-settings.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
let ReferralsComponent = class ReferralsComponent {
    constructor(httpClient, webSettingsService, router, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.webSettingsService = webSettingsService;
        this.router = router;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.userData = {};
        this.referralsData = {};
        this.inputBackColor = '';
        this.secondColor = '';
        this.copiedLink = false;
        this.copiedCode = false;
        this.mainColor = '';
        this.borderRadiusSmaller = '';
        const lang = localStorage.getItem('language');
        this.themeService.getTheme().subscribe((data) => {
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    ngOnInit() {
        this.userData = JSON.parse(localStorage.getItem('user'));
        if (!this.userData) {
            this.router.navigateByUrl('/');
        }
        this.userType = this.userData.user_type_id.type;
        this.httpClient.get('user/referrer').subscribe((data) => {
            this.referralsData = data;
            let onlyPrice = this.referralsData.earnings.split(' ')[0];
            let onlyCurrency = this.referralsData.earnings.split(' ')[1];
            let s = '';
            let temp;
            let num = parseFloat(onlyPrice.replace(/,/g, '') + '').toString().split('.');
            let n = num[0];
            while (n.length > 3) {
                temp = n.substring(n.length - 3);
                s = '.' + temp + s;
                n = n.slice(0, -3);
            }
            if (n) {
                s = n + s;
            }
            if (num[1]) {
                s += ',' + num[1].toString();
            }
            this.referralsData.earnings = s + ' ' + onlyCurrency;
            let onlyPrice2 = this.referralsData.payouts.split(' ')[0];
            let onlyCurrency2 = this.referralsData.payouts.split(' ')[1];
            let s2 = '';
            let temp2;
            let num2 = parseFloat(onlyPrice2.replace(/,/g, '') + '').toString().split('.');
            let n2 = num2[0];
            while (n2.length > 3) {
                temp2 = n2.substring(n2.length - 3);
                s2 = '.' + temp2 + s2;
                n2 = n2.slice(0, -3);
            }
            if (n2) {
                s2 = n2 + s2;
            }
            if (num2[1]) {
                s2 += ',' + num2[1].toString();
            }
            this.referralsData.payouts = s2 + ' ' + onlyCurrency2;
            let onlyPrice3 = this.referralsData.debt.split(' ')[0];
            let onlyCurrency3 = this.referralsData.debt.split(' ')[1];
            let s3 = '';
            let temp3;
            let num3 = parseFloat(onlyPrice3.replace(/,/g, '') + '').toString().split('.');
            let n3 = num3[0];
            while (n3.length > 3) {
                temp3 = n3.substring(n3.length - 3);
                s3 = '.' + temp3 + s3;
                n3 = n3.slice(0, -3);
            }
            if (n3) {
                s3 = n3 + s3;
            }
            if (num3[1]) {
                s3 += ',' + num3[1].toString();
            }
            this.referralsData.debt = s3 + ' ' + onlyCurrency3;
        });
    }
    notify(element) {
        if (element === 'link') {
            document.getElementById('copyButtonLink').classList.add('copied');
            this.copiedLink = true;
            setTimeout(() => {
                document.getElementById('copyButtonLink').classList.remove('copied');
                this.copiedLink = false;
            }, 800);
        }
        else {
            document.getElementById('copyButtonCode').classList.add('copied');
            this.copiedCode = true;
            setTimeout(() => {
                document.getElementById('copyButtonCode').classList.remove('copied');
                this.copiedCode = false;
            }, 800);
        }
    }
};
ReferralsComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: WebClientService },
    { type: Router },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
ReferralsComponent = __decorate([
    Component({
        selector: 'ecd-referrals',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./referrals.component.html")).default
    })
], ReferralsComponent);
export { ReferralsComponent };
